
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('./runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.20.0
 * Query Engine version: 06fc58a368dc7be9fbbbe894adf8d445d208c284
 */
Prisma.prismaVersion = {
  client: "5.20.0",
  engine: "06fc58a368dc7be9fbbbe894adf8d445d208c284"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.PromptScalarFieldEnum = {
  id: 'id',
  prompt: 'prompt',
  answer: 'answer',
  userId: 'userId'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  bubbleId: 'bubbleId',
  email: 'email',
  idVerificationStatus: 'idVerificationStatus',
  emailVerified: 'emailVerified',
  name: 'name',
  surname: 'surname',
  readLanguageGuideOnDate: 'readLanguageGuideOnDate',
  accountType: 'accountType',
  finishedOnboardingOnDate: 'finishedOnboardingOnDate',
  visitedLinktreeOnDate: 'visitedLinktreeOnDate',
  needsEnglishHelp: 'needsEnglishHelp',
  needsFrenchHelp: 'needsFrenchHelp',
  createdDate: 'createdDate',
  modifiedDate: 'modifiedDate',
  admin: 'admin',
  approvedRequests: 'approvedRequests',
  bannedStatus: 'bannedStatus',
  bannedReason: 'bannedReason',
  certnUrl: 'certnUrl',
  declinedRequests: 'declinedRequests',
  didNotShowUp: 'didNotShowUp',
  emailVerificationId: 'emailVerificationId',
  firstVisit: 'firstVisit',
  helpPreferences: 'helpPreferences',
  idCheckRef: 'idCheckRef',
  idVerifiedBy: 'idVerifiedBy',
  eligibilityVerifiedBy: 'eligibilityVerifiedBy',
  idVerifiedOnDate: 'idVerifiedOnDate',
  interestedInLanguageProgram: 'interestedInLanguageProgram',
  lastLoginDate: 'lastLoginDate',
  legalName: 'legalName',
  linkedin: 'linkedin',
  receivedEmailRecLatestDate: 'receivedEmailRecLatestDate',
  receivedEmailRecommendationsDates: 'receivedEmailRecommendationsDates',
  roles: 'roles',
  publicProfile: 'publicProfile',
  testAccount: 'testAccount',
  referralSource: 'referralSource',
  searchableNameEmail: 'searchableNameEmail',
  pendingMatchesCount: 'pendingMatchesCount',
  profileId: 'profileId',
  signupStepsId: 'signupStepsId'
};

exports.Prisma.TeacherScalarFieldEnum = {
  id: 'id',
  createdDate: 'createdDate',
  modifiedDate: 'modifiedDate',
  comment: 'comment',
  userId: 'userId'
};

exports.Prisma.UserAnonymousScoreScalarFieldEnum = {
  userId: 'userId',
  score: 'score',
  modifiedDate: 'modifiedDate'
};

exports.Prisma.CredentialsScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  email: 'email',
  password: 'password',
  createdDate: 'createdDate',
  modifiedDate: 'modifiedDate'
};

exports.Prisma.PasswordResetTokenScalarFieldEnum = {
  id: 'id',
  credentialsId: 'credentialsId',
  token: 'token',
  expiresAt: 'expiresAt',
  used: 'used',
  createdAt: 'createdAt'
};

exports.Prisma.ProfileScalarFieldEnum = {
  id: 'id',
  createdDate: 'createdDate',
  modifiedDate: 'modifiedDate',
  currentCity: 'currentCity',
  currentProvince: 'currentProvince',
  dateOfBirth: 'dateOfBirth',
  familyStructure: 'familyStructure',
  gender: 'gender',
  geolocation: 'geolocation',
  hasAJob: 'hasAJob',
  hasMentor: 'hasMentor',
  highestEducation: 'highestEducation',
  currentIndustry: 'currentIndustry',
  futureIndustry: 'futureIndustry',
  previousIndustry: 'previousIndustry',
  currentJobTitle: 'currentJobTitle',
  futureJobTitle: 'futureJobTitle',
  previousJobTitle: 'previousJobTitle',
  myStory: 'myStory',
  nationality: 'nationality',
  profilePhoto: 'profilePhoto',
  resumeReviewed: 'resumeReviewed',
  whatsapp: 'whatsapp',
  phoneNumber: 'phoneNumber',
  resettlementStatus: 'resettlementStatus',
  userId: 'userId',
  timezone: 'timezone'
};

exports.Prisma.SignupStepsScalarFieldEnum = {
  id: 'id',
  createdDate: 'createdDate',
  modifiedDate: 'modifiedDate',
  slug: 'slug',
  basicInfo: 'basicInfo',
  r1: 'r1',
  r2: 'r2',
  r3: 'r3',
  r4: 'r4',
  r5: 'r5',
  r6: 'r6',
  r7: 'r7',
  r8: 'r8',
  r9: 'r9',
  s1: 's1',
  s2: 's2',
  s3: 's3'
};

exports.Prisma.VideoCallScalarFieldEnum = {
  id: 'id',
  createdDate: 'createdDate',
  modifiedDate: 'modifiedDate',
  slug: 'slug',
  meetingCode: 'meetingCode',
  participantsRawList: 'participantsRawList',
  participantsIds: 'participantsIds',
  url: 'url',
  originalMatchId: 'originalMatchId',
  expectedParticipantsIds: 'expectedParticipantsIds'
};

exports.Prisma.MessageScalarFieldEnum = {
  id: 'id',
  createdDate: 'createdDate',
  modifiedDate: 'modifiedDate',
  slug: 'slug',
  contentFile: 'contentFile',
  contentImage: 'contentImage',
  contentText: 'contentText',
  type: 'type',
  conversationId: 'conversationId',
  visibleByIds: 'visibleByIds',
  seenByIds: 'seenByIds',
  sentById: 'sentById',
  systemMessage: 'systemMessage'
};

exports.Prisma.MatchFeedbackScalarFieldEnum = {
  id: 'id',
  createdDate: 'createdDate',
  modifiedDate: 'modifiedDate',
  slug: 'slug',
  explanation: 'explanation',
  positiveExperience: 'positiveExperience',
  weMet: 'weMet',
  approxMeetingDate: 'approxMeetingDate',
  userId: 'userId',
  countAsImpact: 'countAsImpact',
  matchId: 'matchId'
};

exports.Prisma.MatchScalarFieldEnum = {
  id: 'id',
  createdDate: 'createdDate',
  modifiedDate: 'modifiedDate',
  slug: 'slug',
  acceptedDate: 'acceptedDate',
  adminApprovedDate: 'adminApprovedDate',
  completedDate: 'completedDate',
  matchResponse: 'matchResponse',
  matchStatus: 'matchStatus',
  message: 'message',
  impactCount: 'impactCount',
  createdBySupporter: 'createdBySupporter',
  withdrawnBy: 'withdrawnBy',
  withdrawnSeen: 'withdrawnSeen',
  adminNotes: 'adminNotes',
  localUserId: 'localUserId',
  refugeeUserId: 'refugeeUserId',
  helpPreferences: 'helpPreferences'
};

exports.Prisma.MatchSnapshotScalarFieldEnum = {
  id: 'id',
  discoverIndex: 'discoverIndex'
};

exports.Prisma.LoginScalarFieldEnum = {
  id: 'id',
  createdDate: 'createdDate',
  modifiedDate: 'modifiedDate',
  slug: 'slug',
  loginDate: 'loginDate',
  userId: 'userId'
};

exports.Prisma.LanguageProgramInfoScalarFieldEnum = {
  id: 'id',
  createdDate: 'createdDate',
  p1StartDate: 'p1StartDate',
  p2StartDate: 'p2StartDate',
  modifiedDate: 'modifiedDate',
  slug: 'slug',
  ableToPay: 'ableToPay',
  alreadyInClasses: 'alreadyInClasses',
  availabilityTimezone: 'availabilityTimezone',
  clbListening: 'clbListening',
  clbPlacementTest: 'clbPlacementTest',
  clbReading: 'clbReading',
  clbSpeaking: 'clbSpeaking',
  clbWriting: 'clbWriting',
  clbAssessed: 'clbAssessed',
  confirmNonRefundable: 'confirmNonRefundable',
  finishedSignupOn: 'finishedSignupOn',
  hasVideoCallDevice: 'hasVideoCallDevice',
  status: 'status',
  motivation: 'motivation',
  notes: 'notes',
  p2: 'p2',
  p3: 'p3',
  p4: 'p4',
  p5: 'p5',
  p6: 'p6',
  whereDidYouHearAboutProgram: 'whereDidYouHearAboutProgram',
  whyCantPay: 'whyCantPay',
  userId: 'userId',
  comment: 'comment'
};

exports.Prisma.AvailabilityScalarFieldEnum = {
  id: 'id',
  createdDate: 'createdDate',
  modifiedDate: 'modifiedDate',
  from: 'from',
  to: 'to',
  userId: 'userId'
};

exports.Prisma.LanguageProgramAvailabilityScalarFieldEnum = {
  id: 'id',
  createdDate: 'createdDate',
  modifiedDate: 'modifiedDate',
  slug: 'slug',
  day: 'day',
  timeOfDay: 'timeOfDay',
  from: 'from',
  to: 'to',
  userId: 'userId'
};

exports.Prisma.LanguageScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  createdDate: 'createdDate',
  modifiedDate: 'modifiedDate',
  slug: 'slug',
  language: 'language',
  level: 'level'
};

exports.Prisma.LanguageAssessmentScalarFieldEnum = {
  id: 'id',
  createdDate: 'createdDate',
  createdById: 'createdById',
  languageProgramInfoId: 'languageProgramInfoId',
  clbListening: 'clbListening',
  clbReading: 'clbReading',
  clbSpeaking: 'clbSpeaking',
  clbWriting: 'clbWriting',
  comments: 'comments',
  tenWeeks: 'tenWeeks',
  twentyWeeks: 'twentyWeeks'
};

exports.Prisma.ConversationScalarFieldEnum = {
  id: 'id',
  createdById: 'createdById',
  createdDate: 'createdDate',
  modifiedDate: 'modifiedDate',
  slug: 'slug',
  visibleByIds: 'visibleByIds',
  lastMessageId: 'lastMessageId',
  originalMatchId: 'originalMatchId'
};

exports.Prisma.NotificationPreferenceScalarFieldEnum = {
  id: 'id',
  createdDate: 'createdDate',
  modifiedDate: 'modifiedDate',
  channel: 'channel',
  destinations: 'destinations',
  userId: 'userId'
};

exports.Prisma.SettingsScalarFieldEnum = {
  id: 'id',
  notifications: 'notifications'
};

exports.Prisma.PushSubscriptionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  endpoint: 'endpoint',
  p256dh: 'p256dh',
  auth: 'auth',
  expirationTime: 'expirationTime',
  createdDate: 'createdDate',
  modifiedDate: 'modifiedDate'
};

exports.Prisma.InvalidOrUnreachablePhoneNumberScalarFieldEnum = {
  id: 'id',
  createdDate: 'createdDate',
  errorCode: 'errorCode',
  errorMessage: 'errorMessage'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};
exports.AccountType = exports.$Enums.AccountType = {
  Supporter: 'Supporter',
  Refugee: 'Refugee'
};

exports.HelpPreference = exports.$Enums.HelpPreference = {
  community: 'community',
  language: 'language',
  network: 'network'
};

exports.Roles = exports.$Enums.Roles = {
  Teacher: 'Teacher'
};

exports.NotificationChannel = exports.$Enums.NotificationChannel = {
  Mandatory: 'Mandatory',
  MarketingEmails: 'MarketingEmails',
  MessagesFromHaven: 'MessagesFromHaven',
  MessagesFromMatches: 'MessagesFromMatches',
  HavenLanguageProgram: 'HavenLanguageProgram'
};

exports.NotificationDestination = exports.$Enums.NotificationDestination = {
  Email: 'Email',
  Push: 'Push',
  SMS: 'SMS'
};

exports.Prisma.ModelName = {
  Prompt: 'Prompt',
  User: 'User',
  Teacher: 'Teacher',
  UserAnonymousScore: 'UserAnonymousScore',
  Credentials: 'Credentials',
  PasswordResetToken: 'PasswordResetToken',
  Profile: 'Profile',
  SignupSteps: 'SignupSteps',
  VideoCall: 'VideoCall',
  Message: 'Message',
  MatchFeedback: 'MatchFeedback',
  Match: 'Match',
  MatchSnapshot: 'MatchSnapshot',
  Login: 'Login',
  LanguageProgramInfo: 'LanguageProgramInfo',
  Availability: 'Availability',
  LanguageProgramAvailability: 'LanguageProgramAvailability',
  Language: 'Language',
  LanguageAssessment: 'LanguageAssessment',
  Conversation: 'Conversation',
  NotificationPreference: 'NotificationPreference',
  Settings: 'Settings',
  PushSubscription: 'PushSubscription',
  InvalidOrUnreachablePhoneNumber: 'InvalidOrUnreachablePhoneNumber'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
